import api, { BASE_URL } from "../../api";

const MEDIA_COLLECTION_BASE_URL = `${BASE_URL}/media/collection/`;
const MEDIA_IMAGE_BASE_URL = `${BASE_URL}/media/image/`;



const getCollection = (context, key) => {
  return api(context)
    .get(`${MEDIA_COLLECTION_BASE_URL}${key}/`)
    .then(response => response.data);
};

const uploadToCollection = (context, image) => {
  return api(context)
    .patch(`${MEDIA_COLLECTION_BASE_URL}${product.key}/upload/`, image)
    .then(response => response.data);
};

const deleteImage = (context, key) => {
  return api(context)
    .delete(`${MEDIA_IMAGE_BASE_URL}${key}/`)
    .then(response => response.data);
};

export const mediaCollection = {
  BASE_URL: MEDIA_COLLECTION_BASE_URL,
  get: getCollection,
  image: {
    delete: deleteImage
  }
};

export default mediaCollection



